var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"volumeBox",style:({ height: _vm.height - 10 + 'px' })},[_c('canvas',{class:_vm.rtilCode + 'Left'}),_c('canvas',{class:_vm.rtilCode + 'Right'})])
}
var staticRenderFns = []

export { render, staticRenderFns }